// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dropdown-container {\n  width: 382px;\n}\n\n.dropdown-main-container h4 {\n  color: #2a2c2e;\n  font-size: 1rem;\n  font-weight: 700;\n  margin-bottom: 0.5rem;\n}\n", ""]);
// Exports
module.exports = exports;
